module.exports = __webpack_public_path__ + "static/media/product-guide-2020.4089fca0.png";